/** PURE_IMPORTS_START .._operator_merge PURE_IMPORTS_END */
import { mergeStatic } from '../operator/merge';
export var merge = mergeStatic;
//# sourceMappingURL=merge.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/merge.js
// module id = ./node_modules/rxjs/_esm5/observable/merge.js
// module chunks = vendor